<template>
  <label class="font-medium">
    <slot></slot>
  </label>
</template>
